import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import InvestorDashboard from "./dashboards/InvestorDashboard";
import ServiceDashboard from "./dashboards/ServiceDashboard";
import BankDashboard from "./dashboards/BankDashboard";

const Dashboard = () => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">…</div>;
  if (!user) return <Navigate to="/connexion" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.role === "service_client") return <ServiceDashboard />;
  if (user.role === "bank") return <BankDashboard />;
  return <InvestorDashboard />;
};

export default Dashboard;
